import script from "./PublicInventarioView.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicInventarioView.vue?vue&type=script&setup=true&lang=js"

import "./PublicInventarioView.vue?vue&type=style&index=0&id=4cb3a263&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb3a263"]])

export default __exports__